import React from "react";
import isValidEmail from "taskpane/utils/isValidEmail";
import FormContainer from "./formContainer";
import { RoutePath } from "taskpane/models/enums";
import { useHistory } from "react-router-dom";
import { FormEmail } from "taskpane/models/types";
import useQueryLogin, { IQueryLogin } from "taskpane/hooks/queries/useQueryLogin";
import { useLoading } from "../providers/loadingProvider";
import "../styles/inputField.css";
import { IApiParams, useApiContext } from "taskpane/providers/apiProvider";

export interface ILoginForm extends FormEmail {
  errorMessage?: string;
}

const LoginForm: React.FC<ILoginForm> = (props: ILoginForm): React.JSX.Element => {
  const { setLoading } = useLoading();
  const { fetchConfig } = useApiContext();
  const history = useHistory();
  const [email, setEmail] = React.useState<string>("");
  const [isDisabledButton, setIsDisabledButton] = React.useState<boolean>(true);
  const [errorText, setErrorText] = React.useState<string>("");
  const onChangeEmail = (e: React.ChangeEvent<HTMLInputElement>) => {
    const emailValue: string = e.target.value;
    const isNotValidEmail: boolean = !isValidEmail(emailValue);
    const isNotCorrectLength: boolean = emailValue.length > 100;
    let errorText: string = "";

    if (emailValue && isNotValidEmail) {
      errorText = "Неверный логин";
    } else if (isNotCorrectLength) {
      errorText = "Максимальное количество символов для логина - 100";
    }

    setIsDisabledButton(isNotValidEmail || isNotCorrectLength);
    setErrorText(errorText);
    setEmail(emailValue);
  };
  const getDomainByEmail = (email: string): string => {
    const [, domain] = email.split("@");

    return domain;
  };
  const onSubmitForm = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const domain: string = getDomainByEmail(email);

    setLoading(true);

    fetchConfig(domain, ({ apiUrl, errorMessage }: IApiParams) => {
      if (errorMessage) {
        setErrorText(errorMessage);
        return setLoading(false);
      }

      const queryLoginParams: IQueryLogin = {
        apiUrl: apiUrl,
        email: email,
      };

      useQueryLogin(queryLoginParams, ({ errorMessage }) => {
        setLoading(false);

        if (errorMessage) {
          return setErrorText(errorMessage);
        }

        history.push(RoutePath.passwordPage, { email, domain });
      });
    });
  };

  React.useEffect(() => {
    const email: string = props.email;

    if (email) {
      setEmail(email);
      setIsDisabledButton(false);
    }
  }, [props.email]);

  React.useEffect(() => {
    const { errorMessage } = props;

    if (errorMessage) {
      setErrorText(errorMessage);
    }
  }, [props.errorMessage]);

  return (
    <FormContainer
      title="Введите email"
      description="Введите ваш корпоративный email, на него будет отправлен пароль для входа"
      errorText={errorText}
      isDisabledButton={isDisabledButton}
      onSubmitForm={(e) => onSubmitForm(e)}
    >
      <input
        type="email"
        name="email"
        value={email}
        onChange={(e) => onChangeEmail(e)}
        className="inputField"
        id="emailField"
        placeholder="Логин"
        required
        data-testid="emailField"
      />
    </FormContainer>
  );
};

export default LoginForm;
